function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.411765%,30.196078%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 77.71875 420.019531 L 41.601562 15 L 438.398438 15 L 402.261719 419.960938 L 239.78125 465 Z M 77.71875 420.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,39.607843%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 240 430.558594 L 371.300781 394.160156 L 402.199219 48.121094 L 240 48.121094 Z M 240 430.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 239.5 480 C 237.878906 480 236.261719 479.738281 234.699219 479.21875 L 75.660156 425.621094 C 70.019531 423.71875 66.039062 418.660156 65.519531 412.738281 L 30.058594 16.339844 C 29.679688 12.140625 31.101562 8 33.941406 4.878906 C 36.78125 1.761719 40.800781 0 45 0 L 435 0 C 439.199219 0 443.21875 1.761719 446.058594 4.878906 C 448.898438 8 450.300781 12.140625 449.941406 16.339844 L 414.5 412.738281 C 413.980469 418.679688 409.960938 423.738281 404.320312 425.621094 L 244.261719 479.21875 C 242.71875 479.738281 241.101562 480 239.5 480 Z M 94.519531 400.320312 L 239.519531 449.179688 L 385.5 400.300781 L 418.601562 30 L 61.421875 30 Z M 399.558594 411.398438 L 399.761719 411.398438 Z M 399.558594 411.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 235 380 C 233.058594 380 231.101562 379.621094 229.261719 378.859375 L 144.398438 343.78125 C 139.519531 341.761719 136.058594 337.339844 135.28125 332.121094 L 130.140625 297.199219 C 128.941406 289 134.601562 281.378906 142.800781 280.160156 C 150.941406 278.898438 158.621094 284.621094 159.839844 292.820312 L 163.738281 319.320312 L 235 348.78125 L 306.121094 319.378906 L 317.898438 230 L 139.199219 230 C 131.140625 230 124.5 223.621094 124.199219 215.539062 L 120 100.539062 C 119.859375 96.480469 121.378906 92.519531 124.199219 89.578125 C 127.039062 86.660156 130.921875 85 135 85 L 345 85 C 353.28125 85 360 91.71875 360 100 C 360 108.28125 353.28125 115 345 115 L 150.558594 115 L 153.660156 200 L 335 200 C 339.320312 200 343.421875 201.859375 346.28125 205.101562 C 349.140625 208.359375 350.441406 212.660156 349.878906 216.960938 L 334.738281 331.878906 C 334.039062 337.199219 330.558594 341.738281 325.601562 343.78125 L 240.738281 378.859375 C 238.898438 379.621094 236.941406 380 235 380 Z M 235 380 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.ce1a70abd50bbf0493714e7caa630798.svg";
export { ForwardRef as ReactComponent };